import { AlertTriangle, Lightbulb, Star, type LucideIcon } from 'lucide-react';

import { CALLOUT_VARIANT_LABELS, CALLOUT_VARIANT_STYLE } from '@/lib/callout';
import type { CalloutContent, CalloutVariant, ScriptElement } from '@/lib/schema.types';

const VARIANT_GLYPH: Record<CalloutVariant, LucideIcon> = {
  common_mistake: AlertTriangle,
  memory_trick: Lightbulb,
  important_concept: Star,
};

/**
 * A styled callout box. Variant decides the colour chrome + leading glyph; the
 * classroom mirrors this rendering (parity spec §13).
 */
export function CalloutElement({ element }: { element: ScriptElement }) {
  const c = element.content as CalloutContent | undefined;
  const variant: CalloutVariant = c?.variant ?? 'important_concept';
  const theme = CALLOUT_VARIANT_STYLE[variant];
  const Glyph = VARIANT_GLYPH[variant];
  const title = c?.title?.trim() || CALLOUT_VARIANT_LABELS[variant];

  return (
    <div
      className="flex w-full gap-2 rounded-lg border p-3"
      style={{ background: theme.bg, borderColor: theme.border }}
    >
      <Glyph size={18} color={theme.accent} className="mt-0.5 shrink-0" />
      <div className="min-w-0">
        <div className="text-sm font-semibold" style={{ color: theme.accent }}>
          {title}
        </div>
        <div
          className="whitespace-pre-wrap text-sm"
          style={{ color: (element.style?.color as string | undefined) ?? '#1f2937' }}
        >
          {c?.body || 'Tap to edit this callout.'}
        </div>
      </div>
    </div>
  );
}
